import { CSSProperties, memo, ReactNode } from 'react'
import { GuestLayoutSC, GuestLayoutSCProps } from './styled'
import './guestSiteLogo.css'

export interface GuestLayoutProps extends GuestLayoutSCProps {
  className?: string
  style?: CSSProperties
  children?: ReactNode
}

function GuestLayout({ className, style, children }: GuestLayoutProps) {
  return (
    <GuestLayoutSC className={['guest-layout', className].filter(Boolean).join(' ')} style={style}>
      <div className='content'>{children}</div>
    </GuestLayoutSC>
  )
}

export default memo(GuestLayout)
